import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 13, viewBox: "0 0 8 13", fill: "none", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M6.36784 1.00016L1.20117 6.16683L6.36784 11.3335", stroke: "#102900", strokeWidth: 1.55, strokeLinecap: "round", strokeLinejoin: "round" }));
export {
  o as default
};
